
class BaseComponent {
    
    constructor(aElement){
        
        this.element = $(aElement);
        
    }
    
    attachEvents(){
        
    }
    
    onChange(aName, aValue){
        
    }
    
}

export default BaseComponent;